var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.70139C6.50625 9.70139 7.72727 8.51683 7.72727 7.05556V2.64583C7.72727 1.18456 6.50625 0 5 0C3.49375 0 2.27273 1.18456 2.27273 2.64583V7.05556C2.27273 8.51683 3.49375 9.70139 5 9.70139ZM9.54545 5.29167H9.09091C8.83977 5.29167 8.63636 5.489 8.63636 5.73264V7.05556C8.63636 9.1171 6.80426 10.7713 4.63665 10.5662C2.74744 10.3874 1.36364 8.73979 1.36364 6.89846V5.73264C1.36364 5.489 1.16023 5.29167 0.909091 5.29167H0.454545C0.203409 5.29167 0 5.489 0 5.73264V6.83948C0 9.31003 1.81733 11.5124 4.31818 11.847V12.7882H2.72727C2.47614 12.7882 2.27273 12.9855 2.27273 13.2292V13.6701C2.27273 13.9138 2.47614 14.1111 2.72727 14.1111H7.27273C7.52386 14.1111 7.72727 13.9138 7.72727 13.6701V13.2292C7.72727 12.9855 7.52386 12.7882 7.27273 12.7882H5.68182V11.8575C8.11676 11.5334 10 9.50571 10 7.05556V5.73264C10 5.489 9.79659 5.29167 9.54545 5.29167Z",
    fill: "url(#paint0_linear_2028_1424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2028_1424",
    x1: 13.4872,
    y1: 11.5376,
    x2: 7.62829,
    y2: 16.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.9e1e258938edd57a63d870c780633110.svg";
export { ForwardRef as ReactComponent };